<div class="modal-header">
  <h4 class="modal-title float-left">{{ title | translate }}</h4>
</div>

<div class="modal-body pdf-viewer">
  <ngx-extended-pdf-viewer minZoom="0.5" [base64Src]="fileContents" [height]="'48rem'" [zoom]="'page-fit'"
    [backgroundColor]="'#FFFFFF'" [scrollMode]="3" [showBorders]="false" pageViewMode="single"
    [showFindButton]="false" [showTextEditor]="false" [showDrawEditor]="false" [showSecondaryToolbarButton]="false"
    [showSidebarButton]="false" [sidebarVisible]="false" [showZoomButtons]="false" [showPagingButtons]="true"
    [showPresentationModeButton]="false" [showOpenFileButton]="false" [showPrintButton]="false"
    [showDownloadButton]="true" [showRotateButton]="false" [showHandToolButton]="false" [showSpreadButton]="false"
    [showPropertiesButton]="false">
  </ngx-extended-pdf-viewer>
</div>

<div class="modal-footer">

  @if (pending) {
    <div></div>
    <div class="ball-clip-rotate">
      <div></div>
    </div>
  } @else {
    <div>
      @if (closeBtn) {
        <button type="button" class="btn text-secondary btn-outline-secondary"
        (click)="closeAction()">{{ closeText | translate}}</button>
      }
    </div>
  }

</div>